import { graphql } from "gatsby"
import isEmpty from "~/lib/isEmpty"

export type UDSBackgroundColorComponent = {
  __typename: string
  color:
    | "none"
    | "surface-base"
    | "surface-subtle"
    | "surface-subtlest"
    | "surface-highlight"
    | "surface-base-invert"
    | "surface-subtle-invert"
    | "surface-subtlest-invert"
}

// Values must match real UDS `--color-surface-*` tokens (see
// @ionos-web-design-system/core/dist/brands/*.css) — "surface-elevated" and
// "surface-inverted" were never real tokens, so those classes silently
// resolved to a fully transparent background.
export const BG_CLASS: Record<UDSBackgroundColorComponent["color"], string> = {
  none: "",
  "surface-base": "bg-surface-base",
  "surface-subtle": "bg-surface-subtle",
  "surface-subtlest": "bg-surface-subtlest",
  "surface-highlight": "bg-surface-highlight",
  "surface-base-invert": "bg-surface-base-invert",
  "surface-subtle-invert": "bg-surface-subtle-invert",
  "surface-subtlest-invert": "bg-surface-subtlest-invert",
}

/**
 * Returns the Tailwind bg class, `""` for explicit none, or `undefined` when not configured.
 * Always check with `!== undefined`, never with truthiness.
 */
export function getBgColorClass(
  backgroundColor?: UDSBackgroundColorComponent | null
): string | undefined {
  if (isEmpty(backgroundColor)) {
    return undefined
  }

  return BG_CLASS[backgroundColor.color]
}

export const query = graphql`
  fragment UDSBackgroundColor on GraphCmsSquidex_UdsBackgroundColorComponent {
    __typename
    color
  }
`

export const FRAGMENT_UDS_BACKGROUND_COLOR = `
  fragment UDSBackgroundColor on UdsBackgroundColorComponent {
    __typename
    color
  }
`
